/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        "name": "个人中心",
        "type": "module-name"
    },
    {
        "key": "style_type",
        "name": "样式",
        "type": "personal-info",
        "width": 270,
        "radio-list": [{
            "url": "https://img.mockuai.com/tms/2018/1/11/upload_3850a7f8c250a2f9d23470a9573a9336.png",
            "value": 1
        }, {
            "url": "https://img.mockuai.com/tms/2018/1/17/upload_7153d19ee861c5c518fdcac0deb05c85.png",
            "value": 2
        }, {
            "url": "https://img.mockuai.com/tms/2018/1/11/upload_b0df20e34c95a98ca25b65fb5f958148.png",
            "value": 3
        }]
    },
    {
        "key": "property_data",
        "name": "属性",
        "type": "custom",
        "content": [{
            "key": "is_member_level_show",
            "name": "会员等级",
            "type": "radio-box",
            "radio-list": [{
                "label": "不展示",
                "value": 0
            }, {
                "label": "展示",
                "value": 1
            }]
        }]
    }
];
export default config;